import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './ContactInput.css';

const ContactInput = ({ value, onChange, placeholder }) => {
  const [isPhoneMode, setIsPhoneMode] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      const len = inputRef.current.value.length;
      inputRef.current.setSelectionRange(len, len);
    }
  }, [isPhoneMode]);

  const handleInputChange = (val) => {
    const isLikelyEmail = val.includes("@") && val.includes(".");
    const isLikelyPhone = /^\d{3,}$/.test(val);

    if (isLikelyEmail) {
      setIsPhoneMode(false);
      onChange(val);
    } else if (isLikelyPhone) {
      const formatted = '+30' + val;
      setIsPhoneMode(true);
      onChange(formatted.replace(/\s/g, ''));
    } else {
      setIsPhoneMode(false);
      onChange(val);
    }
  };

  return (
    <div className="contact-input-wrapper">
      {isPhoneMode ? (
        <PhoneInput
          country="gr"
          value={value}
          onChange={(val) => {
            const cleaned = val.replace(/\s/g, '');
            onChange(cleaned.startsWith('+') ? cleaned : '+' + cleaned);
          }}
          enableSearch
          containerClass="contact-phone-input"
          countryCodeEditable={false}
          disableDropdown={false}
          disableCountryCode={false}
          preferredCountries={['gr', 'bg', 'ro', 'al', 'cy', 'mk', 'tr', 'it']}
          inputRef={inputRef}
        />
      ) : (
        <input
          type="text"
          placeholder={placeholder || "Τηλέφωνο ή Email"}
          value={value}
          onChange={(e) => handleInputChange(e.target.value)}
          className="contact-text-input"
          ref={inputRef}
        />
      )}
    </div>
  );
};

export default ContactInput;
